// extracted by mini-css-extract-plugin
export default {"recos":"r6-z","productCardOverride":"s6-z","rowHasBadge":"t6-z"};